/* LUMIRA MOTION 2026 — quiet scroll reveals + add-to-cart feedback.
   Progressive enhancement: no JS or reduced-motion = everything visible, no shift. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('lf-motion');

  var SELECTORS = [
    '.lf-home > section > *:not(.lf-hero__video):not(.lf-hero__veil)',
    '.lf-ar-card', '.lf-tile', '.lf-journal-card',
    '.lf-portfolio-grid a', '.lf-subcategory-card',
    '.product-card', '.card-gallery',
    'main .section:not(.shopify-section-group-header-group *) > .section-content-wrapper'
  ];

  function collect() {
    var seen = new Set();
    var nodes = [];
    SELECTORS.forEach(function (sel) {
      var found;
      try { found = document.querySelectorAll(sel); } catch (e) { return; }
      found.forEach(function (el) {
        if (seen.has(el)) return;
        seen.add(el);
        nodes.push(el);
      });
    });
    return nodes;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('lf-reveal--in');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

  function arm() {
    collect().forEach(function (el, i) {
      if (el.classList.contains('lf-reveal')) return;
      var rect = el.getBoundingClientRect();
      // Elements already in the viewport stay visible — no pop-in on load.
      if (rect.top < window.innerHeight * 0.92) return;
      el.classList.add('lf-reveal');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }

  // Add-to-cart feedback: pulse the button when a cart add succeeds.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!/\/cart\/add/.test(form.action || '')) return;
    var btn = form.querySelector('[type="submit"], .product-form__submit');
    if (!btn) return;
    btn.classList.remove('lf-atc-pulse');
    void btn.offsetWidth;
    btn.classList.add('lf-atc-pulse');
    setTimeout(function () { btn.classList.remove('lf-atc-pulse'); }, 700);
  }, true);
})();
